(function () {
  'use strict';

  function parseConfig(el) {
    try {
      return JSON.parse(el.getAttribute('data-fc-config') || '{}');
    } catch (e) {
      return {};
    }
  }

  function getBreakpoint() {
    var w = window.innerWidth;
    if (w >= 991) return 'desktop';
    if (w >= 768) return 'tablet';
    return 'mobile';
  }

  function destroySwiper(instance) {
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy(true, true);
    }
  }

  function initSection(root) {
    var track = root.querySelector('[data-fc-track]');
    if (!track || typeof Swiper === 'undefined') return null;

    var config = parseConfig(root);
    var bp = getBreakpoint();
    var bpConfig = config[bp] || {};
    var enabled = !!bpConfig.enabled;

    root.classList.toggle('fcollections--slider-active', enabled);
    root.classList.toggle('fcollections--slider-idle', !enabled);
    root.classList.toggle('fcollections--nav-on', enabled && !!bpConfig.showNavigation);
    root.classList.toggle('fcollections--pagination-on', enabled && !!bpConfig.showPagination);

    if (!enabled) {
      return null;
    }

    var paginationEl = root.querySelector('[data-fc-pagination]');
    var prevEl = root.querySelector('[data-fc-prev]');
    var nextEl = root.querySelector('[data-fc-next]');

    var swiperOptions = {
      slidesPerView: bpConfig.slidesPerView || 1,
      spaceBetween: bpConfig.spaceBetween || 0,
      loop: !!bpConfig.loop,
      speed: 300,
      watchOverflow: true,
      grabCursor: true,
      slideToClickedSlide: false,
      // Use the value from config (now false for mobile) instead of
      // hard-coding centeredSlides = true on mobile, which was
      // pushing the layout off a clean 2-up grid.
      centeredSlides: !!bpConfig.centeredSlides,
      breakpoints: undefined
    };

    if (bpConfig.autoplay) {
      swiperOptions.autoplay = {
        delay: bpConfig.autoplayDelay || 5000,
        disableOnInteraction: false
      };
    }

    if (bpConfig.showPagination && paginationEl) {
      swiperOptions.pagination = {
        el: paginationEl,
        clickable: true
      };
    }

    if (bpConfig.showNavigation && prevEl && nextEl) {
      swiperOptions.navigation = {
        prevEl: prevEl,
        nextEl: nextEl
      };
    }

    return new Swiper(track, swiperOptions);
  }

  function setupSection(root) {
    var swiperInstance = null;

    function refresh() {
      destroySwiper(swiperInstance);
      swiperInstance = initSection(root);
    }

    refresh();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 200);
    });

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.contains(root)) refresh();
      });
      document.addEventListener('shopify:block:select', function () {
        if (swiperInstance) swiperInstance.update();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-fc-section]').forEach(setupSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();